import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Pagination from "material-ui-flat-pagination";
import {
  compact,
  find,
  get,
  groupBy,
  isEmpty,
  isNaN,
  noop,
  orderBy,
  omit,
  sortBy,
  debounce,
  padStart,
} from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import { Element } from 'react-scroll';
import Lightbox from 'react-images';
import {
  compose,
  setDisplayName,
} from 'recompose';
import Badge from '@material-ui/core/Badge';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import IconButton from '@material-ui/core/IconButton';
import Radio from '@material-ui/core/Radio';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Apps from '@material-ui/icons/Apps';
import Menu from '@material-ui/icons/Menu';
import Info from '@material-ui/icons/Info';
import Cart from '@material-ui/icons/ShoppingCartOutlined';
import { WarningRounded as WarningIcon, InfoOutlined } from '@material-ui/icons';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { isMobile } from 'helpers/detect-mobile';
import { isMdOrLess } from 'helpers/detect-md';
import PaymentInfoButton from '../../Payments/PaymentInfoButton';
import immutableToJS from 'helpers/immutableToJS';
import {
  formatPrice,
  includesSearchText,
  addTagValue,
  scrollTo,
  toShortDateTimeFormat,
  toStartCase,
  toStartCaseWithSlash,
  toShortestDateFormatMonthFirst,
  boxItemsIds,
  checkIsAddedABox,
  getCartLocalStorage,
} from 'helpers/utils';
import {
  InventoryDescriptionDialog,
  OrderCart,
  QuickHelp,
  SmartTable,
  Tags,
  Avatar,
  HighlightText,
} from 'components';
import { selectState } from 'redux/selectors';
import { FRInput } from 'elements';
import BottomPanel, { getTotalPrice } from './BottomPanel';
import GridView from './GridView';
import OrderSheetTable from './OrderSheetTable';
import PlaceOrderDialog from './PlaceOrderDialog';
import Search from './Search';
import TopPanel from './TopPanel';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import SelectField from 'components/SmartForm/components/SelectField';
import { getAddressIndex, getAddressOptions } from 'helpers/address';


const styles = theme => ({
  activeButton: { backgroundColor: '#fff' },
  activeButtonLabel: { color: '#4695ec' },
  activeViewModeButton: {
    color: '#0093ff',
    height: '1.5em',
    width: '1.5em',
  },
  buttonCancel: {
    backgroundColor: '#FFF',
    borderRadius: 5,
    marginBottom: 5,
    marginRight: 15,
  },
  buttonLabelCancel: {
    color: 'primary',
    fontSize: 16,
    fontWeight: 500,
  },
  button: {
    backgroundColor: '#4caf50',
    borderRadius: 5,
    marginBottom: 5,
    marginRight: 15,
  },
  buttonLabel: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 500,
  },
  fontBold: { fontWeight: 600 },
  icon: { color: '#0000008a' },
  inputLabel: { transform: 'translate(14px, 7px) scale(1);' },
  invalidQtyInput: {
    background: 'white',
    color: 'red',
    height: '90%',
    maxWidth: 50,
    padding: 5,
  },
  normalViewModeButton: {
    color: 'black',
    height: '1.5em',
    width: '1.5em',
  },
  badge: {
    backgroundColor: '#00c308',
    color: 'white',
    fontSize: 15,
    left: 10,
  },
  radio: {
    padding: '0 14px',
  },
  topNavBadge: {
    backgroundColor: '#eb345a',
    color: 'white',
    fontSize: 15,
    left: 10,
  },
  topNavButton: {
    backgroundColor: '#00c308',
    borderRadius: 5,
    marginBottom: 5,
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  validQtyInput: {
    color: 'black',
    height: '90%',
    maxWidth: 50,
    padding: 5,
  },
  controlLabel: {
    flex: 1,
  },
  dialog: {
    maxWidth: 'none',
    width: '90%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginLeft: '0px !important',
    },
  },
  title: { padding: 0 },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 10,
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0px 1px 0px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)',
    borderRadius: '1px !important'
  },
  cardMedia: {
    paddingTop: '60%',
  },
  cardContent: {
    flexGrow: 1,
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingBottom: '5px !important'
  },
  cardMobile: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  cardMediaMobile: {
    width: '80px',
  },
  cardContentMobile: {
    flexGrow: 1,
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '8px',
    paddingBottom: '10px !important'
  }
});

class OrderSheetCardDetail extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    children: PropTypes.node,
    contact: PropTypes.shape({}).isRequired,
    currentUser: PropTypes.shape({}).isRequired,
    deliveryDate: PropTypes.string,
    deliveryFeeOrdered: PropTypes.bool,
    details: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ),
    expanded: PropTypes.bool.isRequired,
    info: PropTypes.shape({}).isRequired,
    invoice: PropTypes.shape({
      delivery_date: PropTypes.string,
    }).isRequired,
    orderedData: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
    ),
    orderRequesting: PropTypes.bool,
    sellersItemsRequesting: PropTypes.bool,
    tags: PropTypes.arrayOf(PropTypes.object),

    addItem: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    handleFocusSearch: PropTypes.func.isRequired,
    placeOrder: PropTypes.func,
    removeItem: PropTypes.func.isRequired,
    handleRefreshSellersItems: PropTypes.func,
    isOpenCartDialog: PropTypes.bool,
    handleOpenCartDialog: PropTypes.func,
    handleCloseCartDialog: PropTypes.func,
    isPlaceOrderButtonDisabled: PropTypes.bool,
    handlePlaceOrderButtonDisabled:PropTypes.func,
    isOpenMergeInvoicesDialog: PropTypes.bool,
    handleCloseMergeInvoicesDialog: PropTypes.func,
    ordersForDeliveryDate: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ),
    orderMerge: PropTypes.number,
    handleChangeOrderMerge: PropTypes.func,
    history: PropTypes.shape({}).isRequired,
    isShopPage: PropTypes.bool,
    homeSections: PropTypes.shape({}),
    selectDeliveryType: PropTypes.func,
    selectFromAddressIndex: PropTypes.func,
    selectToAddressIndex: PropTypes.func,
    hasAnOrderedBox: PropTypes.bool,
    isDoneWithListOrder: PropTypes.bool,
    categoryFilter: PropTypes.string,
    pagingOffsetDefault: PropTypes.number,
    handlePagingOffset: PropTypes.func,
  };

  static defaultProps = {
    children: null,
    deliveryDate: '',
    deliveryFeeOrdered: false,
    details: [],
    orderedData: [],
    orderRequesting: false,
    placeOrder: noop,
    sellersItemsRequesting: false,
    tags: [],
    handleRefreshSellersItems: noop,
    isOpenCartDialog: false,
    handleOpenCartDialog: noop,
    handleCloseCartDialog: noop,
    isPlaceOrderButtonDisabled: false,
    handlePlaceOrderButtonDisabled: noop,
    isOpenMergeInvoicesDialog: false,
    handleCloseMergeInvoicesDialog: noop,
    ordersForDeliveryDate:[],
    orderMerge: -1,
    handleChangeOrderMerge: noop,
    isShopPage: false,
    homeSections: {},
    selectDeliveryType: noop,
    selectFromAddressIndex: noop,
    selectToAddressIndex: noop,
    hasAnOrderedBox: false,
    isDoneWithListOrder: false,
    categoryFilter: "",
    handlePagingOffset:  noop,
  };

  static contextTypes = {
    isPublic: PropTypes.bool,
    isConsumer: PropTypes.bool,
    isRestaurant: PropTypes.bool,
    isDistributor: PropTypes.bool,
    setHotNotification: PropTypes.func,
  };

  state = {
    currentCategory: null,
    inventoryDescription: '',
    fromAddressIndex: 0,
    toAddressIndex: 0,
    searchText: '',
    showInventoryDescriptionDlgOpen: false,
    showMode: true,
    showOrderDlg: false,
    value: {},
    currentImage: 0,
    lightboxIsOpen: false,
    payMethod: null,
    internalNote: null,
    open: false,
    dialogMessage: '',
    pagingLimit: 100,
    pagingOffset: this.props.pagingOffsetDefault,
    disabledButton: false,
    isEnableDeliveryFee: false,
    addPaymentDetailDialogOpen: false,
    requiredLoginOpen: false,
    emailAutoFocus: false,
    boxSizeOpen: false,
    boxSize: '',
    deliveryType: 'deliveryTo',
    isChangedBoxItemQty: false,
    itemDescription: '',
    mobileDescOpen: false,
  };

  componentWillMount() {
    const { selectDeliveryType } = this.props;
    const { deliveryType } = this.state;
    const publicInvoice = getCartLocalStorage();
    if (publicInvoice && publicInvoice.deliveryType) {
      this.setState({ deliveryType: publicInvoice.deliveryType });
      if (publicInvoice.fromAddressIndex !== null && publicInvoice.fromAddressIndex !== undefined) {
        this.setState({ fromAddressIndex: publicInvoice.fromAddressIndex });
      }
      if (publicInvoice.toAddressIndex !== null && publicInvoice.toAddressIndex !== undefined) {
        this.setState({ toAddressIndex: publicInvoice.toAddressIndex });
      }
    } else {
      selectDeliveryType(deliveryType);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.pagingOffsetDefault !== this.state.pagingOffset) {
      this.setState({ pagingOffset: nextProps.pagingOffsetDefault });
    }
  }

  onCancelSearch = () => this.setState({ searchText: '' });

  onSearchItems = (value) => {
    this.setState({ searchText: value, pagingOffset: 0 });
  }

  getContent = (item) => {
    const uoms = sortBy(item.packrows, 'count');

    const content = (
      <div className="content">
        <div className="uoms">
          {
            uoms.map((uom, index) => (
              <div key={index} className="uom">
                <span>{`${uom.count} ${uom.uom} ${uom.pack}`}</span>
                <span>
                  {
                    `$${formatPrice(((uom.price * (100 - (uom.discount || 0))) / 100))}`
                  }
                </span>
              </div>
            ))
          }
        </div>
      </div>
    );
    return content;
  }

  getTitle = (item) => {
    const title = (
      <div className="title">
        <div className="product">
          <div>
            {
              item.productData.name
            }
          </div>
          <div>
            {
              item.productData.subname
            }
          </div>
        </div>
      </div>);

    return title;
  }

  getGroups = () => {
    const { contact, currentUser, details } = this.props;
    const { currentCategory, searchText } = this.state;
    const { isRestaurant } = this.context;
    const data = [];

    if (!details) return [];
    if (details.length > 0) {
      const filteredData = details.filter(subItem => includesSearchText(
        searchText,
        [
          subItem.productData.name,
          subItem.productData.subname,
          get(subItem, 'seller.companyName'),
          subItem.description,
        ],
      ));
      const modifiedDetails = [];
      let totalIndex = 0;

      filteredData.forEach((groupItemInfo) => {
        modifiedDetails.push({
          ...groupItemInfo,
          packrows: groupItemInfo.packrows.map(packrow => ({
            ...omit(packrow, ['id']),
            totalIndex: totalIndex++,
          })),
        });
      });

      const newInfo = groupBy(modifiedDetails, item => item.productData.category);
      const groupItemsInfo = newInfo[currentCategory];
      const categoryField = r => r.productData.category;
      const nameField = r => r.productData.name;
      const subNameField = r => r.productData.name;
      const sortedGroupItems = orderBy(groupItemsInfo, [categoryField, nameField, subNameField, 'index'], ['asc', 'asc', 'asc', 'asc']);
      sortedGroupItems.forEach((groupItemInfo) => {
        if (find(groupItemInfo.packrows,
          item => parseFloat(item.availableQuantity, 10) === 0)) return;
        data.push({
          category: toStartCase(groupItemInfo.productData.category),
          ...groupItemInfo,
          sourcename: groupItemInfo.seller ? get(groupItemInfo, 'seller.companyName') : (isRestaurant ? get(contact, 'sellerProfile.companyName') : get(currentUser, 'account.profile.companyName')),
        });
      });
    }

    return data;
  };

  getGroupsWithoutFilterPaging = (groupsWithoutFilter, pagingLimit, pagingOffset) => {
    return groupsWithoutFilter.slice(pagingOffset, pagingOffset + pagingLimit);
  }

  getGroupsWithoutFilter = () => {
    const { isConsumer, isPublic } = this.context;
    const { contact, details, tags, deliveryDate } = this.props;
    const { searchText } = this.state;
    const data = [];
    const isAllowedZero = this.checkIsAllowedZero(contact);
   
    if (!details) return [];
    if (details.length > 0) {
      const selectedDate = deliveryDate ? moment(deliveryDate).format('YYYY-MM-DD') : '';
      const filteredData = details;
      const modifiedDetails = [];

      filteredData.forEach((groupItemInfo) => {
        const availableDates = groupItemInfo.availableDates && groupItemInfo.availableDates.length > 0 ? groupItemInfo.availableDates : [];
        if ((!isConsumer && !isPublic) || (availableDates.indexOf(selectedDate) !== -1 || !selectedDate)) {
          modifiedDetails.push({
            ...groupItemInfo,
          });
        }
      });

      const filteredModifiedDetails = modifiedDetails.filter(subItem => includesSearchText(
        searchText,
        [
          subItem.productData.name,
          subItem.productData.subname,
          toStartCaseWithSlash(subItem.productData.category),
          !isEmpty(subItem.seller) ? get(subItem, 'seller.companyName') : get(contact, 'sellerProfile.companyName'),
          subItem.description,
          subItem.tags.join(','),
        ],
      ));

      const categoryField = r => r.productData.category;
      const nameField = r => r.productData.name;
      const subNameField = r => r.productData.subname;
      const sortedGroupItems = orderBy(
        addTagValue(filteredModifiedDetails, tags),
        [categoryField, nameField, subNameField, 'tagValue'],
        ['asc', 'asc', 'asc', 'asc'],
      );

      let itemIndex = 0;
      sortedGroupItems.forEach((groupItemInfo) => {
        // if (find(groupItemInfo.packrows,
        //   item => parseFloat(item.availableQuantity, 10) < 1)) return;

        let packrows = [];
        if (groupItemInfo.packrows[0].isBulk) {
          packrows = compact(
            groupItemInfo.packrows.map(packrow => !packrow.invalid &&
              // hide packrow with availableQuantity = 0
              (parseInt(packrow.availableQuantity) >= 1 || isAllowedZero) &&
              // hide packrow with availableQuantity * count < total availableQuantity
              (parseInt(packrow.availableQuantity) * parseInt(packrow.count) <=
              parseInt(groupItemInfo.availableQuantity)) &&
              parseFloat(packrow.price, 10) > 0 &&
              (!groupItemInfo.sellerAccountId || (groupItemInfo.sellerAccountId && parseFloat(packrow.cost, 10) > 0)) && ({
              ...omit(packrow, ['id']),
              totalIndex: `${groupItemInfo.id}-${packrow.count}`,
            })),
          );
        } else {
          packrows = compact(
            groupItemInfo.packrows.map(packrow => !packrow.invalid &&
              // hide packrow with availableQuantity = 0
              (parseInt(packrow.availableQuantity) >= 1 || isAllowedZero) &&
              parseFloat(packrow.price, 10) > 0 &&
              (!groupItemInfo.sellerAccountId || (groupItemInfo.sellerAccountId && parseFloat(packrow.cost, 10) > 0)) && ({
              ...omit(packrow, ['id']),
              totalIndex: `${groupItemInfo.id}-${packrow.count}`,
            })),
          );
        }

        if (packrows.length) {
          data.push({
            category: toStartCase(groupItemInfo.productData.category),
            ...groupItemInfo,
            packrows,
            sourcename: !isEmpty(groupItemInfo.seller) ? get(groupItemInfo, 'seller.companyName') : get(contact, 'sellerProfile.companyName'),
            itemIndex: itemIndex++,
          });
        }
      });
    }

    return data;
  };

  increaseItemQty = (row) => {
    const { setHotNotification } = this.context;
    const { addItem, currentUser } = this.props;

    const value = document.getElementById("qty-public-mobile").value;
    let qty;

    if (value && parseInt(value, 10) !== parseFloat(value)) { // If a decimal
      return;
    }

    const intValue = parseInt(value, 10) + 1;

    const hasAvailableQuantity = this.hasAvailableQuantityLeft(row, intValue);
    if (!hasAvailableQuantity) {
      return;
    }

    if (value === '') {
      qty = 1;
      addItem(row.totalIndex, {
        ...omit(row, ['hide']),
        qty,
      }, true);
      return;

    } else if (intValue > Math.floor(parseFloat(row.availableQuantity))) {
      this.showWarning(row);
      return;
    } else if (intValue <= 0) {
      setHotNotification({
        autoHideDuration: 3000,
        message: 'Quantity cannot be 0 or less',
      });
      return;
    } else {
      qty = intValue;
    }

    addItem(row.totalIndex, {
      ...omit(row, ['hide']),
      qty,
    }, true);

    this.setState({ isChangedBoxItemQty: true });
  }

  decreaseItemQty = (row) => {
    const { setHotNotification } = this.context;
    const { addItem, currentUser } = this.props;

    const value = document.getElementById("qty-public-mobile").value;
    let qty;

    if (value && parseInt(value, 10) !== parseFloat(value)) { // If a decimal
      return;
    }

    const intValue = parseInt(value, 10) - 1;

    const hasAvailableQuantity = this.hasAvailableQuantityLeft(row, intValue);
    if (!hasAvailableQuantity) {
      return;
    }

    if (value === '') {
      qty = '';
    } else if (intValue > Math.floor(parseFloat(row.availableQuantity))) {
      this.showWarning(row);
      return;
    } else if (intValue < 0) {
      setHotNotification({
        autoHideDuration: 3000,
        message: 'Quantity cannot be less than 0',
      });
      return;
    } else if (intValue === 0) { 
      qty = '';
    } else {
      qty = intValue;
    }

    addItem(row.totalIndex, {
      ...omit(row, ['hide']),
      qty,
    }, true);

    this.setState({ isChangedBoxItemQty: true });
  }

  setItemQty = (event, row, shouldRemoveEmpty, isBoxItem = false) => {
    const { setHotNotification } = this.context;
    const { addItem, currentUser } = this.props;
    const { target: { value } } = event;

    let qty;

    if (value && parseInt(value, 10) !== parseFloat(value)) { // If a decimal
      return;
    }

    const intValue = parseInt(value, 10);

    const hasAvailableQuantity = this.hasAvailableQuantityLeft(row, intValue);
    if (!hasAvailableQuantity) {
      return;
    }

    if (value === '') {
      if (shouldRemoveEmpty) {
        addItem(row.totalIndex, undefined, isBoxItem);
        return;
      }
      qty = '';
    } else if (intValue > Math.floor(parseFloat(row.availableQuantity))) {
      this.showWarning(row);
      return;
    } else if (intValue <= 0) {
      setHotNotification({
        autoHideDuration: 3000,
        message: 'Quantity cannot be 0 or less',
      });
      return;
    } else {
      qty = intValue;
    }

    addItem(row.totalIndex, {
      ...omit(row, ['hide']),
      qty,
    }, isBoxItem);
  };

  getItemQty = (row) => {
    const { isConsumer, isPublic } = this.context;
    const { addItem, currentUser, invoice, hasAnOrderedBox, isDoneWithListOrder, removeItem } = this.props;
    const { isChangedBoxItemQty } = this.state;
    const publicInvoice = getCartLocalStorage(invoice);
    const value = document.getElementById("qty-public-mobile") ? document.getElementById("qty-public-mobile").value : null;
    const previousInvoice = invoice.items[row.totalIndex] ? !!(invoice.items[row.totalIndex].qty) : false;
    const previusPublicInvoice = publicInvoice.items[row.totalIndex] ? !!(publicInvoice.items[row.totalIndex]) : false;
    const result = checkIsAddedABox(publicInvoice.items);
    let qty;
    if ((!value && result === 0 && isConsumer && !hasAnOrderedBox && isDoneWithListOrder && !(previousInvoice || previusPublicInvoice)) || (!value && isPublic)) {
      qty = 1;
      addItem(row.totalIndex, {
        ...omit(row, ['hide']),
        qty,
      }, true);
      this.setState({ isChangedBoxItemQty: false });
      return 1;
    } else if (!isChangedBoxItemQty && value === '1' && result > 0 && isConsumer && hasAnOrderedBox && isDoneWithListOrder) {
      removeItem(row.totalIndex);
      this.setState({ isChangedBoxItemQty: true });
      return '';
    } else {
      return (invoice.items[row.totalIndex] || publicInvoice.items[row.totalIndex] || { qty: '' }).qty;
    }
  };

  changeFilterCategories = (categoryName) => {
    this.setState({ currentCategory: categoryName });
  }

  changeFromAddress = (e) => {
    const { selectFromAddressIndex } = this.props;
    this.setState({ fromAddressIndex: e });
    selectFromAddressIndex(e);
  }

  changeToAddress = (e) => {
    const { selectToAddressIndex } = this.props;
    this.setState({ toAddressIndex: e });
    selectToAddressIndex(e);
  }

  changeDeliveryType = (e) => {
    const { selectDeliveryType } = this.props;
    this.setState({ deliveryType: e });
    selectDeliveryType(e);
  }

  changeEnableDeliveryFee = (value) => {
    this.setState({ isEnableDeliveryFee: value });
  }

  handleShowInventoryDescriptionDlgClose = () => {
    this.setState({ showInventoryDescriptionDlgOpen: false });
  }

  handleShowInventoryDescriptionDlgOpen = () => {
    this.setState({ showInventoryDescriptionDlgOpen: true });
  };

  handleCloseOrderDlg = () => this.setState({ showOrderDlg: false });

  handleOpenOrderDlg = value => this.setState({ showOrderDlg: true, value });

  handleClosePlaceOrderDlg = () => {
    const { handleCloseCartDialog } = this.props;
    handleCloseCartDialog();
  };

  handleOpenPlaceOrderDlg = () => {
    const { currentUser } = this.props;
    const { isConsumer, setHotNotification } = this.context;

    if (!currentUser.id) {
      this.setState({ requiredLoginOpen: true });
      return;
    }

    if (isConsumer && !get(currentUser, 'account.paymentDetail.sources.data')) {
      this.openAddPaymentDetailDialog();
      return;
    }

    const { handleRefreshSellersItems, handleOpenCartDialog } = this.props;
    handleRefreshSellersItems();
    handleOpenCartDialog();
  };

  handleCloseMergeInvoicesDlg = () => {
    const { handleCloseMergeInvoicesDialog } = this.props;
    handleCloseMergeInvoicesDialog();
  };

  handleRequiredLoginDialogClose = () => {
    const { history } = this.props;
    this.setState({ requiredLoginOpen: false, emailAutoFocus: true });
    const pathname = history.location.pathname;
    const search = history.location.search;
    history.push(`${pathname}${search}#login`);
  }

  handleOpenBoxSizeDlg = (boxSize) => {
    this.setState({ boxSizeOpen: true, boxSize });
  };

  handleCloseBoxSizeDlg = () => {
    this.setState({ boxSizeOpen: false, boxSize: '' });
  };

  getRefreshSellersItems = () => {
    const { details } = this.props;
    const modifiedData = [];
    if (!details) return [];
    if (details.length > 0) {
      let packRowCount = 0;
      details.forEach((detailsItem) => {
        detailsItem.packrows.forEach((packrow) => {
          if (parseFloat(packrow.availableQuantity, 10) === 0) return;
          packRowCount++;
          if (packRowCount > 1) {
            modifiedData.push({
              ...detailsItem,
              ...packrow,
              id: detailsItem.id,
            });
            return;
          }
          modifiedData.push({
            ...detailsItem,
            ...packrow,
            id: detailsItem.id,
          });
        });
      });
    }
    return modifiedData;
  };

  checkIsAllowedZero = (contact) => {
    const { isPublic } = this.context;
    const sellerRoleId = get(contact, 'sellerProfile.roleId');
    const sellerRole = {
      2: 'Buyer',
      3: 'Distributor',
      4: 'Seller',
      5: 'Consumer',
    }[sellerRoleId] || 'Personal';

    const buyerRoleId = get(contact, 'buyerProfile.roleId');
    const buyerRole = {
      2: 'Buyer',
      3: 'Distributor',
      4: 'Seller',
      5: 'Consumer',
    }[buyerRoleId] || 'Personal';

    return isPublic ? true : (sellerRole === 'Seller' && (buyerRole === 'Buyer' || buyerRole === 'Consumer' || buyerRole === 'Personal'));
  }

  getBuyerRole = (contact) => {
    const buyerRoleId = get(contact, 'buyerProfile.roleId');
    return {
      2: 'Buyer',
      3: 'Distributor',
      4: 'Seller',
      5: 'Consumer',
    }[buyerRoleId] || 'Personal';
  }

  refreshNewOrderedData = (orderedData) => {
    const refreshSellersItems = this.getRefreshSellersItems();
    const newOrderedData = orderedData.map((_item) => {
      const orderedDataItem = Object.assign({}, _item);
      const sellersItems = refreshSellersItems.filter(dataItem =>
        dataItem.id === orderedDataItem.id && dataItem.count === orderedDataItem.count);
      if (sellersItems.length > 0 && sellersItems[0]) {
        orderedDataItem.availableQuantity = parseInt(sellersItems[0].availableQuantity, 10);
      } else {
        orderedDataItem.availableQuantity = 0;
      }
      return orderedDataItem;
    });
    return newOrderedData;
  };

  updateNote = (note) => {
    this.setState({ internalNote: note });
  };
  updateNoteToSeller = (note) => {
    this.setState({ noteToSeller: note });
  };

  showWarning = (row) => {
    const { setHotNotification } = this.context;
    const { formatMessage } = this.props;

    setHotNotification({
      autoHideDuration: 3000,
      message: `${formatMessage('Only available')} ${Math.floor(parseFloat(row.availableQuantity))} item${Math.floor(parseFloat(row.availableQuantity)) !== 1 ? 's' : ''}`,
    });
  };

  hasAvailableQuantityLeft = (row, intValue) => {
    const { setHotNotification } = this.context;
    const { details, orderedData, formatMessage } = this.props;

    const newOrderedData = this.refreshNewOrderedData(orderedData);

    // get total available quantity
    const currentStoreItem = details.filter(detail => detail.id === row.id);
    const totalAvailableQuantity = currentStoreItem && currentStoreItem.length > 0 ?
      parseFloat(currentStoreItem[0].availableQuantity, 10) : 0;

    // calculate current added quantity from other row in the same store item
    let currentAddedQuantity = 0;
    const orderedDataOfStoreItem = newOrderedData.filter(itemData => itemData.id === row.id);
    orderedDataOfStoreItem.forEach((orderedDataItem) => {
      if (orderedDataItem.totalIndex !== row.totalIndex &&
        parseFloat(orderedDataItem.availableQuantity, 10) > 0) {
        currentAddedQuantity += Math.floor(orderedDataItem.qty) *
        Math.floor(orderedDataItem.count);
      }
    });

    // calculate total new quantity and available quantity left in current row
    const rowAvailableQuantity = (totalAvailableQuantity - currentAddedQuantity) / row.count;
    const rowAddedQuantity = intValue;
    if (rowAddedQuantity > Math.floor(parseFloat(rowAvailableQuantity, 10))) {
      const availableQuantityLeft = Math.floor(parseFloat(rowAvailableQuantity, 10));
      setHotNotification({
        autoHideDuration: 3000,
        message: `${formatMessage('Only available')} ${availableQuantityLeft} item${availableQuantityLeft !== 1 ? 's' : ''}`,
      });
      return false;
    }
    return true;
  };

  handleClickOpen = (dialogMessage) => {
    this.setState({ open: true, dialogMessage });
  };

  handleClose = () => {
    this.setState({ open: false, dialogMessage: '' });
  };

  handleCartDialogEntered = () => {
    if (isMobile) {
      var cartDialog = document.getElementById('cart-dialog');
      cartDialog.scrollTo(0, cartDialog.scrollHeight)
    }
  };

  commonFields = (hasUpdatedAtField = true, hasImageField = true) => {
    const { isRestaurant, isDistributor, isConsumer, isPublic } = this.context;
    const { contact, formatMessage } = this.props;
    const { searchText } = this.state;
    const commonFields = [];
  
    commonFields.push(
      {
        className: 'item-name-font highlight large-font-for-mobile',
        colSpan: 3,
        label: formatMessage('IN'),
        name: 'name',
      },
      {
        className: 'item-name-font highlight big-font-for-mobile',
        colSpan: 2,
        label: formatMessage('ISN'),
        name: 'subname',
      },
    );

    if (isPublic) {
      commonFields.push(
        {
          className: 'info item-name-font-consumer',
          colSpan: 3,
          label: formatMessage('Info'),
          mobileHidden: true,
          name: 'description',
          render: row => (
            <span style={{ lineHeight: '15px', fontSize:'13px', color:'#4196f2' }}>
              {row.description }
            </span>),
          title: row => row.description,
        }
      );
    }

    if (!(isConsumer || isPublic)) {
      commonFields.push(
        {
          className: 'info tiny-font',
          colSpan: 2,
          label: formatMessage('Info'),
          mobileHidden: true,
          name: 'description',
          render: row => (
            <span style={{ lineHeight: '15px' }}>
              {row.description ? (`${row.description.substr(0, 57)}${row.description.length > 57 ? '...' : ''}`) : ''}
            </span>),
          title: row => row.description,
        },
        {
          colSpan: 2,
          label: formatMessage('Tags'),
          name: 'tags',
          render: data => (data.tags ? (
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <Tags
                defaultTags={data.tags}
                removable={false}
                showDropdown={false}
                size="small"
              />
            </div>
          ) : null),
          title: () => '',
        },
        {
          className: 'tiny-font',
          colSpan: 2,
          label: formatMessage('Vendor'),
          mobileHidden: true,
          name: 'sourcename',
          title: () => '',
        },
      );
    }
    commonFields.push(
      {
        className: 'medium-font big-font-for-mobile',
        colSpan: 2,
        label: formatMessage('Pack-Out'),
        name: 'uom',
        render: data => `${data.count} ${data.uom} ${data.pack}`,
        render: data => (
          <span style={{ fontWeight: '500', fontSize:'15px', color:'grey' }}>
            {`${data.count} ${data.uom} ${data.pack}`}
          </span>),
      },
      {
        className: `large-font big-font-for-mobile ${contact.defaultDiscount > 0 ? 'strike' : ''}`,
        colSpan: 1,
        label: formatMessage('Price'),
        name: 'price',
        render: data => (
          <span style={{ fontWeight: '500', fontSize:'15px' }}>
              {`$${formatPrice(((data.price * (100 - (data.discount || 0))) / 100))}`}
            </span>),
        title: () => '',
      },
    );

    if (contact.defaultDiscount > 0) {
      commonFields.push({
        className: 'medium-font',
        label: formatMessage('Discounted'),
        name: 'price-based-discount',
        render: data => `$${formatPrice(((data.price * (100 - (parseFloat(contact.defaultDiscount) || 0))) / 100))}`,
        title: () => '',
      });
    }
    commonFields.push({
      label: formatMessage('Total'),
      name: 'priceTotal',
      render: data => `$${formatPrice(((data.price * (100 - (contact.defaultDiscount || 0))) / 100) * data.qty)}`,
      className: 'bold',
      colSpan: 1,
      title: () => '',
    });
    
    if (hasUpdatedAtField) {
      if (!isRestaurant && !isDistributor && !(isConsumer || isPublic)) {
        commonFields.push({
          className: 'tiny-font',
          colSpan: 3,
          label: formatMessage('Update'),
          mobileHidden: true,
          name: 'updatedAt',
          render: data => toShortDateTimeFormat(data.updatedAt),
          title: () => '',
        });
      }
    }

    return commonFields;
  }

  isNullOrEmpty = (value) => {
    return (!value || value.length === 0);
  }

  checkAvailableQuantities = (item) => {
    let result = true;
    item.packrows.forEach((packrow) => {
      if (parseFloat(packrow.availableQuantity, 10) === 0) {
        result = false;
      }
    });
    return result;
  }

  fieldsPublicStore = () => {
    const { formatMessage, invoice, classes, deliveryDate } = this.props;
    const { setHotNotification, isConsumer, isPublic } = this.context;
    const { searchText } = this.state;
    const publicInvoice = getCartLocalStorage(invoice);
    const commonFields = this.commonFields().filter(item => item.label !== 'Total' && item.label !== 'Vendor');

    const fieldsPublicStore = [];

    fieldsPublicStore.push({
      label: formatMessage('Image'),
      name: 'image',
      render: data => !!data.image && !!data.image.trim() && (
        <img
          src={data.image}
          alt={data.productData ? `${data.productData.category}: ${data.productData.name}` : data.image}
          style={{ width: 35, height: 35, objectFit: 'unset', cursor: 'pointer' }}
          onClick={() => this.openLightbox(data)}
        />
      ),
      title: formatMessage('Image'),
      colSpan: 1,
    });

    fieldsPublicStore.push(
      {
        label: formatMessage('Qty'),
        mobileLabel: formatMessage('Enter Qty'),
        name: 'qty',
        render: (row) => {
          return (row.invalid ? <WarningIcon /> : (
            <div>
              {Math.floor(parseFloat(row.availableQuantity)) > 0 && (
                <TextField
                  autoComplete="none"
                  id="qty-public"
                  onClick={() => {
                    if (deliveryDate) return true;
                    setHotNotification('Enter order date');
                    return false;
                  }}
                  InputLabelProps={{
                    classes: {
                      root: classes.label,
                    },
                  }}
                  InputProps={{
                    readOnly: !deliveryDate,
                    classes: {
                      input: (get(invoice.items[row.totalIndex], 'qty') || 0) === 0 ? classes.invalidQtyInput : classes.validQtyInput,
                    },
                  }}
                  max={parseFloat(row.availableQuantity, 10)}
                  min={0}
                  name="qty-public"
                  onChange={(event) => {
                    this.setItemQty(event, row, true);
                  }}
                  placeholder="0"
                  style={{ maxWidth: 50 }}
                  step="1"
                  type="number"
                  value={(invoice.items[row.totalIndex] || publicInvoice.items[row.totalIndex] || { qty: '' }).qty}
                  variant="outlined"
                />
              )}
            </div>)
          )
        },
        title: () => '',
        searchDisabled: false,
      },
      {
        label: '',
        name: 'availableQuantity',
        render: row => (
          <div style={{ width: '100%', textAlign: isConsumer ? 'right' : '' }}>
            <Fragment>
              <span className="red" style={{ paddingRight: 10, color: 'grey'  }}>
              {Math.floor(parseFloat(row.availableQuantity)) > 0 ? Math.floor(parseFloat(row.availableQuantity)) : 'Sold Out'}
              </span> 
              <span className="italic" style={{color: 'grey'}}>{Math.floor(parseFloat(row.availableQuantity)) > 0 ? 'left' : ''}</span>
            </Fragment>
          </div> || '0'),
        mobileHidden: true,
        title: () => '',
      },
      ...commonFields,
    );

    fieldsPublicStore.push({
      className: 'tiny-font wrap-vendor',
      colSpan: 2,
      label: formatMessage('Vendor'),
      mobileHidden: true,
      name: 'sourcename',
      title: () => '',
    }
    );

    return fieldsPublicStore;
  }

  fieldsPublicStoreForMobile = () => {
    const { contact, formatMessage, invoice, classes, deliveryDate } = this.props;
    const { setHotNotification, isConsumer, isPublic } = this.context;
    const fieldsPublicStoreForMobile = [
      {
        label: formatMessage('IN'),
        name: 'name',
        colSpan: 3,
        className: 'highlight',
        render: row => (
          <div>
            <div className="mobile-group-data-first-order-sheet">
              <div className="first-pane">
                <div className="mobile-group-data-item highlight" style={{fontSize:'20px', fontWeight:500}}>
                  {[row.name, row.subname].join(', ')}
                </div>
                <div className="mobile-group-data-item">
                  {
                    row.tags ? (
                      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <Tags
                          defaultTags={row.tags}
                          removable={false}
                          showDropdown={false}
                          size="small"
                        />
                      </div>
                    ) : null
                  }
                </div>
              </div>
            </div>
          </div>
        ),
      },
      {
        label: '',
        name: 'order',
        colSpan: 3,
        className: 'highlight',
        render: row => (
          <div>
            <div style={{ marginTop: '10px' }} className="mobile-group-data-first-order-sheet">
              <div className="mobile-group-data-item highlight weight-600">
                <div className="ordered-table-first-qty">
                  {Math.floor(parseFloat(row.availableQuantity)) > 0 && (
                    <TextField
                      autoComplete="none"
                      id="qty-public-mobile"
                      InputProps={{
                        readOnly: !deliveryDate,
                        classes: {
                          input: (get(invoice.items[row.totalIndex], 'qty') || 0) === 0 ? classes.invalidQtyInput : classes.validQtyInput,
                        },
                      }}
                      InputLabelProps={{
                        classes: {
                          root: classes.label,
                        },
                      }}
                      max={parseFloat(row.availableQuantity, 10)}
                      min={0}
                      name="qty-public-mobile"
                      onClick={() => {
                        if (deliveryDate) return true;
                        setHotNotification('Enter order date');
                        return false;
                      }}
                      onChange={(event) => {
                        this.setItemQty(event, row, true);
                      }}
                      style={{
                        height: 30,
                        maxWidth: 40,
                      }}
                      placeholder="0"
                      type="number"
                      step="1"
                      value={(invoice.items[row.totalIndex] || { qty: '' }).qty}
                      variant="outlined"
                    />
                  )}
                  <div className="order-item-font pl-1">
                    {((isConsumer || isPublic)) ?
                      Math.floor(parseFloat(row.availableQuantity)) <= 0 &&
                      <Fragment>
                        <span className="red">
                          {formatMessage('Sold Out')}
                        </span>
                        <span className="italic">{Math.floor(parseFloat(row.availableQuantity)) > 0 ? 'left' : ''}</span>
                      </Fragment>
                      : (
                        <Fragment>
                          <span className="red" style={{ paddingRight: 10 }}>
                            {Math.floor(parseFloat(row.availableQuantity)) > 0 ? Math.floor(parseFloat(row.availableQuantity)) : 'Sold Out'}
                          </span>
                          <span className="italic">{Math.floor(parseFloat(row.availableQuantity)) > 0 ? 'left' : ''}</span>
                        </Fragment>
                      )
                    }
                  </div>
                </div>
              </div>
              <div className="mobile-group-data-item order-item-font">
                {`${row.count} ${row.uom} ${row.pack}`}
              </div>
              <div className={`mobile-group-data-item highlight order-item-font ${contact.defaultDiscount > 0 ? 'strike' : ''}`}>
                {`$${formatPrice(((row.price * (100 - (row.discount || 0))) / 100))}`}
              </div>
              {contact.defaultDiscount > 0 && (
                <div className="mobile-group-data-item highlight order-item-font">
                  {`$${formatPrice(((row.price * (100 - (parseFloat(contact.defaultDiscount) || 0))) / 100))}`}
                </div>
              )}
              {!!row.imageMobile && (
                <div className="second-pane">
                  <img
                    src={row.imageMobile}
                    alt={row.imageMobile}
                    style={{
                      height: 40,
                      objectFit: 'unset',
                      width: 40,
                      cursor: 'pointer',
                    }}
                    onClick={() => this.openLightbox(row)}
                  />
                </div>
              )}
            </div>
          </div>
        ),
      },
      {
        label: '',
        name: 'description',
        colSpan: 3,
        className: 'highlight',
        render: row => ( 
          <div style={{marginTop: '10px'}} >
            {row.description}
          </div> ),
        title: row => row.description,
      },
      {
        label: '',
        name: 'category',
        colSpan: 3,
        className: 'highlight',
        render: row => (
          <div>
            <div className="item-details-row container">
              <div className="row">
                <div style={{ padding: 0, textAlign: 'start' }} className="item-details-sourcename col-6">
                  {row.sourcename}
                </div>
                <div style={{ padding: 0, textAlign: 'end' }} className="item-details-category col-6">
                  {row.category}
                </div>
              </div>
            </div>
          </div>
        ),
      }
    ];
    return fieldsPublicStoreForMobile;
  }

  orderedFields = () => {
    const { formatMessage, classes, contact } = this.props;
    const orderedFields = [];

    orderedFields.push(
      {
        label: formatMessage('Image'),
        name: 'image',
        render: data => !!data.image && !!data.image.trim() && (
          <img
            src={data.image}
            alt={data.productData ? `${data.productData.category}: ${data.productData.name}` : data.image}
            style={{ width: 50, height: 50, objectFit: 'unset', cursor: 'pointer' }}
            onClick={() => this.openLightbox(data)}
          />
        ),
        title: formatMessage('Image'),
        colSpan: 1,
      },
      {
        colSpan: 1,
        label: formatMessage('Qty'),
        name: 'qty',
        render: row => (
          <TextField
            id="qty"
            InputProps={{
              classes: { input: `${classes.invalidQtyInput} ${classes.fontBold}` },
            }}
            InputLabelProps={{
              classes: {
                root: classes.label,
              },
            }}
            max={Math.floor(parseFloat(row.availableQuantity))}
            min={0}
            name="qty"
            onChange={(event) => {
              this.setItemQty(event, row, false);
            }}
            style={{ maxWidth: 100 }}
            type="number"
            value={row.qty}
            variant="outlined"
            disabled={Math.floor(parseFloat(row.availableQuantity)) === 0}
          />
        ),
        noTitle: true,
      },
      {
        className: 'item-name-font highlight large-font-for-mobile',
        colSpan: 3,
        label: formatMessage('IN'),
        name: 'name',
      },
      {
        className: 'item-name-font highlight big-font-for-mobile',
        colSpan: 2,
        label: formatMessage('ISN'),
        name: 'subname',
      },
      {
        className: 'medium-font big-font-for-mobile',
        colSpan: 2,
        label: formatMessage('Pack-Out'),
        name: 'uom',
        render: data => `${data.count} ${data.uom} ${data.pack}`,
        render: data => (
          <span style={{ fontWeight: '500', fontSize:'15px', color:'grey' }}>
            {`${data.count} ${data.uom} ${data.pack}`}
          </span>),
      },
      {
        className: `large-font big-font-for-mobile ${contact.defaultDiscount > 0 ? 'strike' : ''}`,
        colSpan: 1,
        label: formatMessage('Price'),
        name: 'price',
        render: data => (
          <span style={{ fontWeight: '500', fontSize:'15px' }}>
              {`$${formatPrice(((data.price * (100 - (data.discount || 0))) / 100))}`}
            </span>),
        title: () => '',
      }
    );

    if (contact.defaultDiscount > 0) {
      orderedFields.push({
        className: 'medium-font',
        label: formatMessage('Discounted'),
        name: 'price-based-discount',
        render: data => `$${formatPrice(((data.price * (100 - (parseFloat(contact.defaultDiscount) || 0))) / 100))}`,
        title: () => '',
      });
    }

    orderedFields.push({
      label: formatMessage('Total'),
      name: 'priceTotal',
      render: data => `$${formatPrice(((data.price * (100 - (contact.defaultDiscount || 0))) / 100) * data.qty)}`,
      className: 'bold',
      colSpan: 1,
      title: () => '',
    });

    orderedFields.push(
      {
        label: '',
        name: 'action',
        noTitle: true,
        colSpan: 1,
      },
    );
   
    return orderedFields;
  }

  orderedFieldsForMobile = () => {
    const {
      formatMessage,
      classes,
      contact,
    } = this.props;
    const {
      searchText
    } = this.state;
    const orderedfieldsForMobile = [
      {
        label: '',
        name: 'name',
        colSpan: 6,
        className: 'highlight',
        render: row => (
          <div className="mobile-group-data-first">
            <div className={`mobile-group-data-item mr-2 highlight weight-500 ${row.approved ? '' : 'disable'}`}
              style={{fontSize:'20px'}}
            >
              <HighlightText
                highlight={searchText}
                text={[row.name, row.subname].join(', ')}
              />
            </div>
            {
              row.tags ? (
                <div className={classes.flexWrap}>
                  <Tags
                    defaultTags={row.tags}
                    removable={false}
                    showDropdown={false}
                    size="small"
                  />
                </div>
            ) : null
            }
            {
              row.imageMobile ? (
                <img
                  src={row.imageMobile}
                  alt={row.imageMobile}
                  style={{ width: 40, height: 40, objectFit: 'unset' }}
                />
              ) : null
            }
          </div>
        ),
      },
      {
        label: '',
        name: 'order',
        colSpan: 6,
        className: 'highlight',
        render: row => (
          <div className="mobile-group-data-first-order-sheet align-middle">
            <div className="first-pane">
              <div className="mobile-group-data-item highlight bold">
                {`${row.count} ${row.uom} ${row.pack}`}
              </div>
              <div className={`mobile-group-data-item highlight weight-600 ${contact.defaultDiscount > 0 ? 'strike' : ''}`}>
                {`$${formatPrice(((row.price * (100 - (row.discount || 0))) / 100))}`}
              </div>
              {contact.defaultDiscount > 0 && (
                <div className="mobile-group-data-item highlight weight-600">
                  {`$${formatPrice(((row.price * (100 - (parseFloat(contact.defaultDiscount) || 0))) / 100))}`}
                </div>
              )}
            </div>
            {/* <div className="second-pane">
              <div className="mobile-group-data-item">
                {
                  row.action
                }
              </div>
            </div> */}
          </div>
        ),
      },
      {
        label: '',
        name: 'description',
        colSpan: 3,
        className: 'highlight',
        render: row => ( 
          <div style={{marginTop: '10px', marginBottom: '8px'}} >
            {row.description}
          </div> ),
        title: row => row.description,
      },
      {
        label: formatMessage('IN'),
        name: 'name',
        colSpan: 3,
        className: 'highlight',
        render: row => (
          <div className="mobile-group-data-first-order-sheet">
            <div className="first-pane" style={{justifyContent: 'flex-start'}}>
              <div className="mobile-group-data-item">
                <TextField
                  id="qty-mobile"
                  InputLabelProps={{
                    classes: {
                      root: classes.label,
                    },
                  }}
                  InputProps={{
                    classes: { input: `${classes.invalidQtyInput} ${classes.fontBold} ${row.qty > Math.floor(parseFloat(row.availableQuantity)) ? 'quantity-red' : ''}` },
                  }}
                  max={Math.floor(parseFloat(row.availableQuantity))}
                  min={0}
                  name="qty-mobile"
                  autoComplete="none"
                  onChange={(event) => {
                    this.setItemQty(event, row, false);
                  }}
                  style={{
                    height: 30,
                    maxWidth: 30,
                  }}
                  type="number"
                  value={row.qty}
                  variant="outlined"
                  disabled={Math.floor(parseFloat(row.availableQuantity)) === 0}
                />
              </div>
              <div className="small-font pl-1">
                <span>
                  <span className="red">
                    {Math.floor(parseFloat(row.availableQuantity))}&nbsp;
                  </span>
                  <span className="italic">{formatMessage('left')}</span>
                </span>
              </div>
              {/* <div className="mobile-group-data-item highlight weight-600">
                {row.name}
              </div>
              <div className="mobile-group-data-item highlight weight-600">
                {row.subname}
              </div> */}
            </div>
            {/* <div className="second-pane">
              <div className="mobile-group-data-item highlight weight-600">
                {
                  Boolean(row.image) && (
                    <img
                      src={row.image}
                      alt={row.image}
                      style={{ width: 50, height: 50, objectFit: 'unset' }}
                    />)
                }
              </div>
            </div> */}
              <div style={{ padding: 0, textAlign: 'start', fontSize:'12px', color: '#718ca8' }} className="item-details-sourcename col-6">
                  {row.sourcename}
              </div>
              <div className="second-pane">
                <div className="mobile-group-data-item">
                  {
                    row.action
                  }
                </div>
            </div>

          </div>
        ),
      },
    
    ];
    return orderedfieldsForMobile;
  }

  openLightbox = (item) => {
    const imageIndex = this.lightboxImages.findIndex(i => i.itemId === item.id);

    this.setState({ currentImage: imageIndex >= 0 ? imageIndex : 0, lightboxIsOpen: true });
  }

  closeLightbox = () => this.setState({ currentImage: 0, lightboxIsOpen: false })

  gotoPreviousImage = () => this.setState({ currentImage: this.state.currentImage - 1 })

  gotoNextImage = () => this.setState({ currentImage: this.state.currentImage + 1 })

  gotoImage = index => this.setState({ currentImage: index })

  handleClickLightboxImage = () => {
    if (this.state.currentImage === this.lightboxImages.length - 1) return;
    this.gotoNextImage();
  }

  refreshCategories = (props) => {
    const { searchText } = this.state;
    const filteredData = props.details.filter(subItem =>
      this.checkAvailableQuantities(subItem) && includesSearchText(
        searchText,
        [
          subItem.productData.name,
          subItem.productData.subname,
          subItem.sourcename,
          subItem.description,
        ],
      ));
    const newInfo = groupBy(filteredData, item => item.productData.category);
    const originalCategories = sortBy(Object.keys(newInfo));
    const categories = originalCategories.map(detail => ({
      name: detail,
      length: newInfo[detail].length,
    }));

    this.setState({
      currentCategory: get(categories, '0.name'),
    });
  };

  showInfo = (inventoryDescription) => {
    this.setState({ inventoryDescription });
    this.handleShowInventoryDescriptionDlgOpen();
  };

  scrollToCart = () => {
    scrollTo('go-to-date-picker');
  };

  toggleForShowMode = (toggled) => {
    this.setState({ showMode: toggled });
  };

  handleChangePayMethod = (e, payMethod) => this.setState({ payMethod });

  openAddPaymentDetailDialog = () => {
    this.setState( { addPaymentDetailDialogOpen: true });
  };

  handlePlaceOrder = (isForTopNav, orderedData = [], fromAddressIndex, toAddressIndex, deliveryType, sellerNoteData, buyerNoteData, noteToSeller) => {
    const { setHotNotification, isConsumer, isPublic } = this.context;
    const { placeOrder, handlePlaceOrderButtonDisabled, orderMerge, invoice, hasAnOrderedBox } = this.props;

    const invoiceForPublic = getCartLocalStorage(invoice);
    const result = checkIsAddedABox(invoiceForPublic.items);
    if (result === 0 && (isConsumer || isPublic) && !hasAnOrderedBox) {
      setHotNotification('Please order a box first');
      return;
    }

    //disable place order button when place an order
    handlePlaceOrderButtonDisabled(true);

    if (isForTopNav) {
      this.scrollToCart();
      return;
    }

    // validate quantity
    for (let i = 0; i < orderedData.length; i++) {
      const item = orderedData[i];
      if (parseInt(item.qty, 10) <= 0) {
        setHotNotification({
          autoHideDuration: 3000,
          message: 'Quantity cannot be 0 or less',
        });
        return;
      }
    }

    const newOrderedData = orderedData.map((_item) => {
      const item = Object.assign({}, _item);
      item.sellerNote = sellerNoteData;
      item.buyerNote = buyerNoteData;
      item.noteToSeller = noteToSeller;
      return item;
    });
    const orderMergeId = isConsumer ? -1 : parseInt(orderMerge,10);

    // place order now
    placeOrder(
      newOrderedData,
      fromAddressIndex,
      toAddressIndex,
      deliveryType,
      this.currentPayMethod,
      orderMergeId,
      this.handleOpenPlaceOrderDlg,
      this.handleClosePlaceOrderDlg,
    );
  };

  handleChangeOrderMerge = (e, orderMerge) => {
    const { handleChangeOrderMerge } = this.props;
    handleChangeOrderMerge(orderMerge);
  }

  renderToggleView = () => {
    const { classes } = this.props;
    const { showMode } = this.state;

    return (
      <div className="view-toggle">
        <div className="view-mode">
          <IconButton
            key="grid-view"
            onClick={() => this.setState({ showMode: false })}
            style={{ padding: 10 }}
          >
            <Apps classes={{ root: showMode ? classes.normalViewModeButton
              : classes.activeViewModeButton }} />
          </IconButton>
          <IconButton
            key="table-view"
            onClick={() => this.setState({ showMode: true })}
          >
            <Menu classes={{ root: showMode ? classes.activeViewModeButton
              : classes.normalViewModeButton }} />
          </IconButton>
        </div>
      </div>
    );
  };

  onAddPaymentDetailDialogClose = () => {
    this.setState({ addPaymentDetailDialogOpen: false });
  };

  getDataGrouped = (data) => {
    const { contact } = this.props;
    const isAllowedZero = this.checkIsAllowedZero(contact);
    const modifiedData = [];
    if (!data) return [];
    if (data) {
      let packRowCount = 0;
      data.packrows.forEach((packrow) => {
        if (parseFloat(packrow.availableQuantity, 10) === 0 && !isAllowedZero) return;
        packRowCount++;
        if (packRowCount > 1) {
          modifiedData.push({
            category: toStartCase(data.productData.category),
            ...data,
            ...packrow,
            hide: [
              'action',
              'category',
              'description',
              'image',
              'name',
              'sourcename',
              'status',
              'subname',
              'tags',
              'updatedAt',
            ],
            id: data.id,
            name: data.productData.name,
            subname: data.productData.subname,
          });
          return;
        }
        modifiedData.push({
          category: toStartCase(data.productData.category),
          ...data,
          ...packrow,
          id: data.id,
          name: data.productData.name,
          subname: data.productData.subname,
        });
      });
    }

    return modifiedData;
  };

  handleOpenDescDlg = (ev) => {
    this.setState({ mobileDescOpen: true, itemDescription: ev.row.description });
  }

  handleCloseDescDlg = () => {
    this.setState({ mobileDescOpen: false, itemDescription: '' });
  }

  render() {
    const { isConsumer, isPublic, setHotNotification } = this.context;
    const {
      addItem,
      children,
      classes,
      contact,
      currentUser,
      deliveryDate,
      deliveryFeeOrdered,
      expanded,
      info,
      invoice,
      formatMessage,
      handleFocusSearch,
      orderedData,
      orderRequesting,
      sellersItemsRequesting,
      placeOrder,
      removeItem,
      tags,
      isOpenCartDialog,
      handleOpenCartDialog,
      handleCloseCartDialog,
      isPlaceOrderButtonDisabled,
      isOpenMergeInvoicesDialog,
      handleCloseMergeInvoicesDialog,
      ordersForDeliveryDate,
      orderMerge,
      history,
      isShopPage,
      categoryFilter,
      pagingOffsetDefault,
      handlePagingOffset,
      ...props
    } = this.props;
    const {
      inventoryDescription,
      fromAddressIndex,
      toAddressIndex,
      searchText,
      showInventoryDescriptionDlgOpen,
      showMode,
      showOrderDlg,
      internalNote,
      noteToSeller,
      value,
      payMethod,
      currentImage,
      lightboxIsOpen,
      open,
      dialogMessage,
      pagingLimit,
      pagingOffset,
      isEnableDeliveryFee,
      addPaymentDetailDialogOpen,
      requiredLoginOpen,
      emailAutoFocus,
      boxSizeOpen,
      boxSize,
      deliveryType,
      itemDescription,
      mobileDescOpen,
    } = this.state;

    const orderedFieldsForMobile = this.orderedFieldsForMobile();
    const orderedFields = this.orderedFields();
    const fieldsPublicStoreForMobile = this.fieldsPublicStoreForMobile();
    const fieldsPublicStore = this.fieldsPublicStore();
    const defaultDiscount = contact.defaultDiscount || 0;
    const defaultDeliveryFee = contact.defaultDeliveryFee || (this.getBuyerRole(contact) == "Consumer" || this.getBuyerRole(contact) == "Personal" ? 10 : 0);
    const defaultPayMethod = get(currentUser, 'account.paymentDetail.default_source');
    const creditUsable = get(currentUser, 'account.creditUsable');
    const newOrderedData = this.refreshNewOrderedData(orderedData);
    const totalPrice = getTotalPrice({
      data: newOrderedData,
      defaultDiscount,
      defaultDeliveryFee,
      deliveryFeeOrdered,
    });
    let payMethods = (get(currentUser, 'account.paymentDetail.sources.data') || []).map(({ id, object, last4 }) => ({
      id,
      label: formatMessage(object === 'card' ? 'Card' : 'ACH'),
      subLabel: `*${last4}`,
      code: object === 'card' ? 'card' : 'ach',
      helper: object === 'card'
        ? (contact.payMode === 'ach' || contact.payMode === 'coin'
          ? formatMessage('This vendor does not accept Card.')
          : formatMessage('Money will be authorized immediately and captured automatically later.')
        )
        : (contact.payMode === 'card' || contact.payMode === 'coin'
          ? formatMessage('This vendor does not accept ACH.')
          : formatMessage('Money will be captured automatically later.')
        ),
      disabled: ((contact.payMode === 'card' || contact.payMode === 'coin') && object !== 'card') || ((contact.payMode === 'ach' || contact.payMode === 'coin') && object === 'card'),
    }));
    payMethods = orderBy(
      payMethods,
      [
        ({ disabled }) => disabled,
        ({ id }) => id === defaultPayMethod,
        ({ object }) => object === 'bank_account',
      ],
      ['asc', 'desc', 'desc'],
    );
    this.currentPayMethod = payMethod;
    if (!payMethod) {
      this.currentPayMethod = (payMethods.find(({ disabled }) => !disabled) || {}).id;
    }
    if (contact.netMode && contact.netMode.startsWith('manual')) {
      payMethods = [];
      this.currentPayMethod = contact.netMode;
    }
    let groupsWithoutFilter = this.getGroupsWithoutFilter();

    const categoryFilterWithOutSlash = categoryFilter.replace(/\//g, " ");
    // keep only category filter
    groupsWithoutFilter = categoryFilter != "" ? groupsWithoutFilter.filter(item => item.category.replace(/\s/g, '') == categoryFilterWithOutSlash.replace(/\s/g, '')) : groupsWithoutFilter;

    //remove boxes from table
    const groupsWithoutFilterWithoutBoxes =groupsWithoutFilter.filter(item => boxItemsIds.indexOf(item.id) === -1);
    let groupsWithoutFilterPaging = this.getGroupsWithoutFilterPaging(groupsWithoutFilterWithoutBoxes, pagingLimit, pagingOffset);

    const currentDate = new Date(moment(deliveryDate).local());
    const isInValidDate = isNaN(currentDate.getTime());

    this.lightboxImages = groupsWithoutFilter.filter(g => (showMode || !g.hide) && !!g.image)
      .map(({ id, image, productData }) => ({
        itemId: id,
        src: image,
        caption: `${productData.category} - ${productData.name}, ${productData.subname}`,
      }));

    const CartBadge = (({ isForTopNav }) => newOrderedData.length > 0 && (
      <Badge
        badgeContent={newOrderedData.length}
        classes={{ badge: isForTopNav ? classes.topNavBadge : classes.badge }}
      >
        <Typography />
      </Badge>
    ));

    let actualCategory = "";

    const PlaceOrderButton = (({ isForTopNav }) => (
      <div className="button-panel">
        {isForTopNav ? (
          <Fragment>
            <span className="d-md-down-none">
              {formatMessage('Cart')}
            </span>
            <IconButton
              className={`${classes.icon}`}
              onClick={() => this.handleOpenPlaceOrderDlg()}
              >
              { newOrderedData.length > 0 && (
                <Badge
                  badgeContent={newOrderedData.length}
                  classes={{ badge: isForTopNav ? classes.topNavBadge : classes.badge }}
                >
                  <Cart style={{ fontSize: 30 }} />
                </Badge>
              )}
            </IconButton>
          </Fragment>
        ) : (
          <Button
            classes={{
              label: classes.buttonLabel,
              root: isForTopNav ? classes.topNavButton : classes.button,
            }}
            className="place-order-button"
            disabled={isForTopNav
              ? orderRequesting
              : (newOrderedData.length === 0 || orderRequesting)
            }
            variant="contained"
            onClick={() =>
              this.handleOpenPlaceOrderDlg()}
            >
            <div className="order-cart-content">
              {formatMessage('Cart / Check-Out')}
              <div style={{ display: 'flex', alignItems: 'center', width: 30 }}>
                <CartBadge isForTopNav />
              </div>
            </div>
          </Button>
        ) }
      </div>
    ));

    if (!expanded) return null;

    const logoImage = info.logoUrl;
    const avatar = (
      <Avatar
        fullName={info.companyName}
        src={logoImage}
        size={40}
      />
    );

    const sellerNoteData = null; // info.type === 'PO' ? null : internalNote;
    const buyerNoteData = internalNote; // info.type === 'PO' ? internalNote : null;
    const actions = [
      <div className="order-sheet-draft" style={{float: isMobile ? '' : 'right'}}>
        <div className="order-sheet-top"style={{padding: 0}} >
          <div className="order-sheet-top-right-panel">
            <BottomPanel
              data={newOrderedData}
              defaultDiscount={defaultDiscount}
              isEnableDeliveryFee={isEnableDeliveryFee}
              defaultDeliveryFee={defaultDeliveryFee}
              deliveryFeeOrdered={deliveryFeeOrdered}
              formatMessage={formatMessage}
            />
          </div>
        </div>   
      </div>,
      <div style={{margin: 'auto', width: '330px', textAlign:'center'}}>
        <Button
        classes={{
          label: classes.buttonLabelCancel,
          root: classes.buttonCancel,
        }}
        className="place-order-button"
        key="close"
        onClick={this.handleClosePlaceOrderDlg}
        variant="contained"
        >
          Shop More
        </Button>
        <Button
        classes={{
          label: classes.buttonLabel,
          root: classes.button,
        }}
        className="place-order-button"
        key="okay"
        disabled={isPlaceOrderButtonDisabled}
        onClick={() =>
          this.handlePlaceOrder(false, newOrderedData, fromAddressIndex, toAddressIndex, deliveryType
            , sellerNoteData, buyerNoteData, noteToSeller)}
        variant="contained"
      >
        Place Order
      </Button>
      </div>
    ];
    const note = info.type === 'PO' ? info.buyerNote : info.sellerNote;
    const isInvisibleCalendar = true;
    
    //Data for Dialog merge invoices
    const listOrdersToMerge = [];
    ordersForDeliveryDate.forEach((order) => {
      listOrdersToMerge.push({
        label: 'Merge with (' + toShortestDateFormatMonthFirst(order.deliveryDate) + ') Invoice #' + order.orderNum,
        id: order.id,
      });
    });
    listOrdersToMerge.push({label:'New Order', id:-1});
    const currentOrderMerge = parseInt(orderMerge, 10);

    const totalInfo = (
      <React.Fragment>
      <div className="order-sheet-draft">
        <div className={`order-sheet-top`} style={{ paddingTop: '0px' }}>
          <div className={`order-sheet-top-right-panel`}>
            <div>
              <BottomPanel
                data={newOrderedData}
                defaultDiscount={defaultDiscount}
                isEnableDeliveryFee={isEnableDeliveryFee}
                defaultDeliveryFee={defaultDeliveryFee}
                deliveryFeeOrdered={deliveryFeeOrdered}
                formatMessage={formatMessage}
              />
            </div>
            <div className="place-orer-button" style={{ marginTop: '15px', display: 'flex', flexDirection: 'column', alignItems:'flex-end' }} >
              <RadioGroup
                aria-label="Pay Method"
                name="pay-method"
                value={this.currentPayMethod}
                onChange={this.handleChangePayMethod}
              >
                {payMethods.map(({ id, label, subLabel, disabled, helper }) => (
                  <FormControlLabel
                    value={id}
                    key={id}
                    control={<Radio className={classes.radio} />}
                    style={{ marginLeft: -5, marginBottom: 5, flex: 1 }}
                    disabled={disabled}
                    classes={{ label: classes.controlLabel }}
                    label={(
                      <div
                        className="d-flex align-items-center justify-content-between"
                      >
                        <span
                          style={{
                            fontWeight: this.currentPayMethod === id ? 'bold' : 'normal',
                            marginRight: 10,
                          }}
                        >
                          {label}
                          <span style={{ fontSize: 10, color: 'gray' }}> {subLabel}</span>
                        </span>
                        <QuickHelp>{helper}</QuickHelp>
                      </div>
                    )}
                  />
                ))}
              </RadioGroup>
              <PlaceOrderButton />
            </div>
          </div>
        </div>
      </div>
      <div className="date-picker-title" style={{marginTop: 40}}>
        {formatMessage('Order Date')}: <span style={{ color: 'red' }}>{isInValidDate ? '' : moment(currentDate).local().format('DD MMM YYYY')}</span>
      </div>
      </React.Fragment>
    );

    const buyerAddress = contact.buyerProfile && contact.buyerProfile.addresses ? contact.buyerProfile.addresses[toAddressIndex] : {};
    const deliveryToAddress = [
      buyerAddress.address,
      buyerAddress.city,
      buyerAddress.state && buyerAddress.zipcode ? `${buyerAddress.state || ''} - ${buyerAddress.zipcode || ''}` : '',
    ].join(', ');

    const sellerAddress = contact.sellerProfile && contact.sellerProfile.addresses ? contact.sellerProfile.addresses[fromAddressIndex] : {};
    const pickUpAddress = [
      sellerAddress.address,
      sellerAddress.city,
      sellerAddress.state && sellerAddress.zipcode ? `${sellerAddress.state || ''} - ${sellerAddress.zipcode || ''}` : '',
    ].join(', ');

    const toAddresses =
      get(contact, 'buyerProfile.addresses') ||
      get(buyer, 'account.profile.addresses');
    const toAddressList = getAddressOptions(toAddresses);


    return (
      <div className={`order-sheet-detail `} style={{width: '100%'}}>
        <OrderCart>
          {
            expanded && newOrderedData.length > 0 && (
              <PlaceOrderButton isForTopNav />
            )
          }
        </OrderCart>
        <TopPanel
          {...props}
          contact={contact}
          changeFromAddress={this.changeFromAddress}
          changeToAddress={this.changeToAddress}
          changeDeliveryType={this.changeDeliveryType}
          deliveryType={deliveryType}
          deliveryDate={deliveryDate}
          fromAddressIndex={fromAddressIndex}
          toAddressIndex={toAddressIndex}
          totalInfo={totalInfo}
          changeEnableDeliveryFee={this.changeEnableDeliveryFee}
          history={history}
          isShopPage={isShopPage}
          emailAutoFocus={emailAutoFocus}
        />
        <div>
          {children}
          <Search
            cancelSearch={this.onCancelSearch}
            onChange={debounce(this.onSearchItems, 500)}
            placeholder={formatMessage('Items or Vendor')}
            searchText={searchText}
          />
          <div id="table-items"></div>

          {
            showMode ? (
              !sellersItemsRequesting ? (
                //Grid view only for sellers stores
                contact.sellerProfile.roleId === 4 ? (
                <div>
                  <div className="smart-table">
                    <div className={`grid-view ${classes.root}`}>
                      {groupsWithoutFilterPaging.length > 0 &&
                        <GridView
                          addItem={addItem}
                          info={groupsWithoutFilterPaging}
                          invoice={invoice}
                          isCardMobile={isMobile ? true : false}
                          isOrderingGrid={true}
                        >
                          {
                            sortBy(groupsWithoutFilterPaging, ['category', 'productData.name', 'packrows[0].count']).filter(item => !item.hide).map((item, index) => {
                              const data = this.getDataGrouped(item);
                              return (
                                data.map((row, index) => {
                                  const val = formatPrice(((row.price * (100 - (row.discount || 0))) / 100)).toString();
                                  const dec_pos = val.indexOf('.');
                                  const showCategoryTitle = actualCategory === row.category ? false : true;
                                  actualCategory = row.category;
                                  const imageUrl = row.image || '/assets/images/image-not-available-1.png';
                                  
                                  return (
                                    isMobile ? (
                                      <Grid item key={index} xs={12} sm={12} md={12} style={{padding: 0}}>
                                        {showCategoryTitle && <div style={{fontSize:22, fontWeight: 300, color:"grey", paddingBottom:15, paddingTop:15, paddingLeft:15, textAlign:"left"}}>{row.category}</div> }
                                      <Card className={classes.cardMobile}>
                                        <div>
                                          <img src={imageUrl} alt="" width="170" height="130" style={{objectFit:'cover'}}></img>
                                        </div>
                                        <CardContent className={classes.cardContentMobile}>
                                          <Typography gutterBottom variant="h5" component="h2" style={{ fontSize: "17px", fontWeight: 500 }}>
                                            {row.name},
                                            <span>&nbsp;{row.subname.substring(0,13)} {row.subname.length > 13 ? "..." : ""}  </span>
                                            <span style={{ fontWeight: 300 }}>{row.tags.join(", ")}  </span>
                                          </Typography>
                                         <div style={{display: 'flex', justifyContent: 'space-between', alignItems:'center', marginTop: "10px", marginBottom: "10px"}}>
                                            <div key={index} className="uom" style={{ fontSize: "13px", color:"grey" }}>
                                                <span>{`${row.count} ${row.uom} ${row.pack}`}</span>
                                              </div>
                                              <div style={{ fontSize: "16px", fontWeight: 400 }} >
                                                <span>
                                                  {`${val.substring(0, dec_pos)}`}<sup style={{fontWeight: 300}}> { `${val.substring(dec_pos + 1)}`}</sup>
                                                </span>
                                              </div>
                                              <div style={{ display: "flex", justifyContent: "space-between", color: "rgb(65, 150, 242)" }}>
                                            <div>
                                            </div>
                                            <div className="card-qty-field">
                                              {Math.floor(parseFloat(row.availableQuantity)) > 0 && (
                                                <TextField
                                                  autoComplete="none"
                                                  id="qty-public"
                                                  onClick={() => {
                                                    if (deliveryDate) return true;
                                                    setHotNotification('Enter delivery date');
                                                    return false;
                                                  }}
                                                  InputLabelProps={{
                                                    classes: {
                                                      root: classes.label,
                                                    },
                                                  }}
                                                  InputProps={{
                                                    readOnly: !deliveryDate,
                                                    classes: {
                                                      input: (get(invoice.items[row.totalIndex], 'qty') || 0) === 0 ? classes.invalidQtyInput : classes.validQtyInput,
                                                    },
                                                  }}
                                                  max={parseFloat(row.availableQuantity, 10)}
                                                  min={0}
                                                  name="qty-public"
                                                  onChange={(event) => {
                                                    this.setItemQty(event, row, true);
                                                  }}
                                                  placeholder="0"
                                                  style={{ maxWidth: 50 }}
                                                  step="1"
                                                  type="number"
                                                  value={(invoice.items[row.totalIndex] || { qty: '' }).qty}
                                                  variant="outlined"
                                                />
                                              )}
                                              {Math.floor(parseFloat(row.availableQuantity)) <= 0 && (
                                                <span style={{color: 'red'}}>SOLD OUT</span>
                                              )}
                                            </div>
                                          </div>
                                              
                                         </div>
                                         {row.description.length > 0 && (
                                            <div style={{ fontSize: "12px", color:"grey" }}>
                                              <Button
                                                onClick={(event) => {
                                                  this.handleOpenDescDlg({ event, row });
                                                }}
                                                style={{padding: '0px', color: '#1e88e5', textTransform: 'none', minHeight:'auto', fontSize: '12px', fontWeight: 400}}
                                              >
                                                {row.description.substring(0, 25)} {row.description.length > 25 ? "..." : ""}
    
                                              </Button>
                                            </div>  
                                          )
                                         }
                                        </CardContent>
                                      </Card>
                                    </Grid>
                                    )
                                    : (
                                    <Grid item key={index} style={{width: '240px'}} >
                                      <Card className={classes.card}>
                                        <CardMedia
                                          className={classes.cardMedia}
                                          image={imageUrl}
                                          title=""
                                        />
                                        <CardContent className={classes.cardContent}>
                                          <Typography gutterBottom variant="h5" component="h2" style={{ fontSize: "17px", fontWeight: 500 }}>
                                            {row.name},<span>&nbsp;{row.subname}  </span>
                                            <span style={{ fontWeight: 300 }}>{row.tags.join(", ")}  </span>
                                          </Typography>
                                          <div style={{ marginTop: "8px", fontSize: "12px", color: '#151b1e80' }}>
                                            <Button
                                              onClick={(event) => {
                                                this.handleOpenDescDlg({ event, row });
                                              }}
                                              style={{ padding: '0px', color: '#1e88e5', textTransform: 'none', minHeight: 'auto', fontSize: '12px', fontWeight: 400, textAlign: 'left' }}
                                            >
                                              {row.description.substring(0, 35)} {row.description.length > 35 ? "..." : ""}
                                            </Button>
                                          </div>
                                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: "10px", marginBottom: "10px" }}>
                                            <div key={index} className="uom" style={{ fontSize: "13px", fontWeight: 'bold' }}>
                                              <span>{`${row.count} ${row.uom} ${row.pack}`}</span>
                                            </div>
                                            <div style={{ fontSize: "16px", fontWeight: 'bold' }} >
                                              <span>
                                                {`${val.substring(0, dec_pos)}`}<sup> {`${val.substring(dec_pos + 1)}`}</sup>
                                              </span>
                                            </div>
                                            <div style={{ display: "flex", justifyContent: "space-between", color: "rgb(65, 150, 242)" }}>
                                              <div>
                                                {/* TODO. get farm name */}
                                              </div>
                                              <div className="card-qty-field">
                                                {Math.floor(parseFloat(row.availableQuantity)) > 0 && (
                                                  <TextField
                                                    autoComplete="none"
                                                    id="qty-public"
                                                    onClick={() => {
                                                      if (deliveryDate) return true;
                                                      setHotNotification('Enter delivery date');
                                                      return false;
                                                    }}
                                                    InputLabelProps={{
                                                      classes: {
                                                        root: classes.label,
                                                      },
                                                    }}
                                                    InputProps={{
                                                      readOnly: !deliveryDate,
                                                      classes: {
                                                        input: (get(invoice.items[row.totalIndex], 'qty') || 0) === 0 ? classes.invalidQtyInput : classes.validQtyInput,
                                                      },
                                                    }}
                                                    max={parseFloat(row.availableQuantity, 10)}
                                                    min={0}
                                                    name="qty-public"
                                                    onChange={(event) => {
                                                      this.setItemQty(event, row, true);
                                                    }}
                                                    placeholder="0"
                                                    style={{ maxWidth: 40 }}
                                                    step="1"
                                                    type="number"
                                                    value={(invoice.items[row.totalIndex] || { qty: '' }).qty}
                                                    variant="outlined"
                                                  />
                                                )}
                                                {Math.floor(parseFloat(row.availableQuantity)) <= 0 && (
                                                  <span style={{ color: 'red', fontSize: '12px' }}>SOLD OUT</span>
                                                )}
                                              </div>
                                            </div>

                                          </div>
                                        </CardContent>
                                      </Card>
                                    </Grid>
                                  )
                                  )
                                })
                              )
                            }
                            )
                          }
                        </GridView>
                      }
                    </div>

                    {/* {
                      isMdOrLess && <OrderSheetTable.OrderSheetMobileTable
                        threshold="md"
                      >
                        {
                          groupsWithoutFilterPaging.map((groupItem, index) => (
                            <OrderSheetTable.OrderSheetMobileTableRow
                              data={groupItem}
                              fields={fieldsPublicStoreForMobile}
                              key={index}
                              threshold="md"
                              isAllowedZero={this.checkIsAllowedZero(contact)}
                            />
                          ))
                        }
                      </OrderSheetTable.OrderSheetMobileTable>
                    } */}
                  </div>
                </div>
                ) : 
                // Table view for distributors stores
                (
                  <div className="smart-table">
                    <div className="ordersheet-pagination">
                      <Pagination
                        limit={this.state.pagingLimit}
                        offset={this.state.pagingOffset}
                        total={groupsWithoutFilter.length}
                        onClick={(e, offset) => {
                          this.setState({pagingOffset: offset})
                          handlePagingOffset(offset)
                          }
                        }
                      />
                    </div>
                  
                  { !isMdOrLess && groupsWithoutFilterPaging.length > 0 &&
                  <OrderSheetTable
                    fields={fieldsPublicStore}
                    threshold="md"
                  >
                    {
                      groupsWithoutFilterPaging.map((groupItem, index) => (
                        <OrderSheetTable.OrderSheetTableRow
                          data={groupItem}
                          fields={fieldsPublicStore}
                          key={index}
                          searchText={searchText}
                          isAllowedZero={this.checkIsAllowedZero(contact)}
                          classes={classes}
                        />
                      ))
                    }
                  </OrderSheetTable>
                  }
                  {
                    isMdOrLess && <OrderSheetTable.OrderSheetMobileTable
                      threshold="md"
                    >
                      {
                        groupsWithoutFilterPaging.map((groupItem, index) => (
                          <OrderSheetTable.OrderSheetMobileTableRow
                            data={groupItem}
                            fields={fieldsPublicStoreForMobile}
                            key={index}
                            threshold="md"
                            isAllowedZero={this.checkIsAllowedZero(contact)}
                          />
                        ))
                      }
                    </OrderSheetTable.OrderSheetMobileTable>
                  }
                  <div className="ordersheet-pagination">
                    <Pagination
                      limit={this.state.pagingLimit}
                      offset={this.state.pagingOffset}
                      total={groupsWithoutFilter.length}
                      onClick={(e, offset) => {
                        this.setState({pagingOffset: offset})
                        handlePagingOffset(offset)
                        }
                      }
                    />
                  </div>
                </div>
                )
                )
                : (
                  <div className="ordersheet-progress">
                    <CircularProgress />
                  </div>
                )
              ) : (
                <div className={`grid-view ${classes.root}`}>
                  <GridView
                    addItem={addItem}
                    info={groupsWithoutFilter}
                    invoice={invoice}
                  >
                    {
                      groupsWithoutFilter.filter(item => !item.hide).map((item, index) => (
                        <GridListTile
                          className="grid-title"
                          key={index}
                          style={{
                            border: '1px solid grey',
                            height: 220,
                          }}
                        >
                          <img
                            alt=""
                            className="item-image"
                            onClick={() => this.openLightbox(item)}
                            src={item.image}
                          />
                          <GridListTileBar
                            actionIcon={
                              <IconButton
                                className={classes.icon}
                                onClick={() => this.handleOpenOrderDlg(item)}
                              >
                                <Info />
                              </IconButton>
                            }
                            title={this.getTitle(item)}
                          />
                        </GridListTile>
                      ))
                    }
                  </GridView>
                  <GridView.MobileGridView
                    threshold="md"
                  >
                    {
                      groupsWithoutFilter.filter(item => !item.hide).map((item, index) => (
                        <GridListTile
                          className="grid-title"
                          key={index}
                          style={{
                            border: '1px solid grey',
                            height: 220,
                          }}
                        >
                          <img
                            alt=""
                            className="item-image"
                            onClick={() => this.openLightbox(item)}
                            src={item.image}
                          />
                          <GridListTileBar
                            actionIcon={
                              <IconButton
                                className={classes.icon}
                                onClick={() => this.handleOpenOrderDlg(item)}
                              >
                                <Info />
                              </IconButton>
                            }
                            title={this.getTitle(item)}
                          />
                        </GridListTile>
                      ))
                    }
                  </GridView.MobileGridView>
                </div>
              )
          }
        </div>
        <Lightbox
          currentImage={currentImage}
          images={this.lightboxImages}
          isOpen={lightboxIsOpen}
          onClickImage={this.handleClickLightboxImage}
          onClickNext={this.gotoNextImage}
          onClickPrev={this.gotoPreviousImage}
          onClickThumbnail={this.gotoImage}
          onClose={this.closeLightbox}
          showThumbnails
        />
        <InventoryDescriptionDialog
          info={inventoryDescription}
          onRequestClose={this.handleShowInventoryDescriptionDlgClose}
          open={showInventoryDescriptionDlgOpen}
        />
        <PlaceOrderDialog
          addItem={addItem}
          info={value}
          invoice={invoice}
          onRequestClose={this.handleCloseOrderDlg}
          open={showOrderDlg}
        />
        <Dialog
          open={open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Description</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              { dialogMessage }
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          classes={{ paper: classes.dialog }}
          onClose={this.handleClose}
          open={isOpenCartDialog}
          scroll="body"
          id="cart-dialog"
          onEntered = {this.handleCartDialogEntered}
        >
          <DialogContent className={`order-detail-dialog order-sheets-page`}>
            <div className={ isMobile ? 'd-block' : 'd-flex align-items-center'} style={{fontSize: 18}}>
              <div className="d-flex align-items-center" style={{padding: '0px 20px 0px 20px'}}>
                {avatar}
                <span style={{marginLeft:15}}> {get(info, 'companyName')} </span>
              </div>
              <div className={ isMobile ? 'd-block' : 'd-flex align-items-center'} style={{padding: '0px 20px 0px 20px', margin: isMobile ? '10px 0px 10px 0px' : ''}}>
                  <div style={{marginRight: 20}}>To: <b>{contact.buyerProfile.companyName}</b></div>
                  {
                    contact.buyerProfile.addresses && (
                      <div>
                        <SelectField
                          classes={{
                            root: { root: classes.selectRoot },
                            label: { root: classes.selectFloatingLabel },
                            select: { select: classes.selectLabel },
                          }}
                          defaultValue={toAddressIndex}
                          fullWidth
                          name="address"
                          onChange={e => changeToAddress(e)}
                          options={toAddressList}
                        />
                      </div>
                    )}
                </div>
            </div>
            {orderRequesting && (
              <div className="customer-progress">
                <CircularProgress />
              </div>
            )}
            <div className={ isMobile ? 'd-block' : 'd-flex align-items-center'} >
              <div className="d-flex" style={{ alignItems: 'center', padding: '0px 0px 0px 20px', fontSize: '20px', width: '215px' }}>
                {deliveryType === 'deliveryTo' ? <span> {formatMessage('Delivery')} </span> : formatMessage('Pick-Up Date') }: <span style={{ color: 'red' }}>{isInValidDate ? '' : moment(currentDate).local().format('DD MMM')}</span>
              </div>
              <div className="d-flex" style={{  alignItems: 'center', width: '100%', padding: '0px 20px 10px 20px' }}>
                <div style={{ color: 'gray' }}>
                  {formatMessage('internal note:')}
                </div>
                <FRInput
                  defaultValue={note}
                  onBlur={({ target: { value } }) => {
                    if (note !== value) {
                      this.updateNote(value);
                    }
                  }}
                  onKeyPress={({ keyCode, which, target: { value } }) =>
                    (which === 13 || keyCode === 13) && this.updateNote(value)
                  }
                  style={{ margin: '7px 5px', fontSize: 18, flex: 1 }}
                />
              </div>
            </div>
            <div>
              <div className="order-sheet-draft" style={{ backgroundColor: '#FFF' }}>
                <Element name="order-table-for-scroll">
                  <div className="d-md-down-none order-table">
                    <div className="order-table-before" />
                    <SmartTable
                      data={newOrderedData}
                      fields={orderedFields}
                      style={{
                        maxHeight: 350,
                        overflowY: 'auto',
                      }}
                      isCartDialog
                    />
                    <div className="order-table-after" />
                  </div>
                </Element>
                <Element className="d-lg-up-none" name="mobile-order-table-for-scroll">
                  <div className="order-table">
                    <div className="order-table-before" />
                    {
                      newOrderedData.length ? (
                        <div style={{
                          maxHeight: 249,
                          overflowX: 'hidden',
                          overflowY: 'auto',
                        }}>
                          <div className="smart-table">
                            {
                              <OrderSheetTable.OrderSheetMobileTable
                                threshold="md"
                              >
                                {
                                  newOrderedData.map((groupItem, index) => (
                                    <OrderSheetTable.OrderSheetMobileTableRow
                                      data={groupItem}
                                      fields={orderedFieldsForMobile}
                                      isOrderedTable
                                      key={index}
                                      threshold="md"
                                    />
                                  ))
                                }
                              </OrderSheetTable.OrderSheetMobileTable>
                            }
                          </div>
                        </div>)
                        : ''
                    }
                    <div className="order-table-after" />
                  </div>
                </Element>
              </div>
            </div>
          </DialogContent>
          <DialogActions className="order-sheets-page" style={{ display:'block' }}>{actions}</DialogActions>
        </Dialog>
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          aria-labelledby="confirmation-dialog-title"
          open={!isConsumer && isOpenMergeInvoicesDialog}
          maxWidth='md'
        >
          <IconButton
            aria-label="Close"
            className={classes.closeButton}
            onClick={this.handleCloseMergeInvoicesDlg}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent style={{marginTop:'42px'}}>
            <RadioGroup
              aria-label="list-orders-merge"
              name="ordersToMerge"
              value={currentOrderMerge}
              onChange={this.handleChangeOrderMerge}
            >
              {listOrdersToMerge.map(({id, label}) => (
                <FormControlLabel 
                  value={id} 
                  key={id} 
                  control={<Radio />} 
                  label={(
                    <div className="d-flex align-items-center justify-content-between">
                      <span> {label} </span> 
                    </div>
                  )} 
                />
              ))}
            </RadioGroup>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseMergeInvoicesDlg} color="primary" autoFocus variant="contained" >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={requiredLoginOpen}
          onClose={this.handleRequiredLoginDialogClose}
          >
          <DialogTitle></DialogTitle>
          <DialogContent>
            <DialogContentText style={{ color: '#151b1e' }}>
              <div>
                <div style={{ marginBottom: '20px', fontSize: '20px' }}>
                  {formatMessage('Log-In or Sign-Up to Place Your Order.')}
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
            <Button onClick={this.handleRequiredLoginDialogClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          className="box-size-dialog"
          open={boxSizeOpen}
          onClose={this.handleCloseBoxSizeDlg}
          >
          <DialogTitle></DialogTitle>
          <DialogContent style={{ width: '100%' }}>
            <DialogContentText style={{ color: '#151b1e' }}>
              <div style={{ marginTop: '-80px' }}>
                <div style={{ marginBottom: '20px', fontSize: '20px' }}>
                  <iframe src={`/products?category=${boxSize}`} style={{ border: 'none' }}></iframe>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
            <Button onClick={this.handleCloseBoxSizeDlg} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        {/* card description  */}
        <Dialog
          className="mobile-desc-dialog"
          open={mobileDescOpen}
          onClose={this.handleCloseDescDlg}
        >
          <DialogTitle></DialogTitle>
          <DialogContent style={{ width: '100%' }}>
            <DialogContentText style={{ color: '#151b1e' }}>
              <div>
                {itemDescription}
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
            <Button onClick={this.handleCloseDescDlg} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('options', 'tags')(state, 'tags'),
  ...selectState('options', 'homeSections')(state),
});

export default compose(
  setDisplayName('OrderSheetCardDetail'),
  connect(mapStateToProps),
  withStyles(styles),
  immutableToJS,
)(OrderSheetCardDetail);
